module.exports = __webpack_public_path__ + "img/1f.61a3c1c1.png";